import { useState } from 'react'
import { useGetQuery } from 'hooks'
import { Modal, Tag, Title, Typeahead } from '../../../components'

const addSlug = (arry) => {
  return arry?.map((a) => ({ ...a, slug: `${a.subject}:${a.action}` }))
}

export const EditRole = ({ role, toggle }) => {
  const { data: roleData } = useGetQuery({ enabled: !!role, url: role ? `/admin/roles/${role}` : null })
  const { data: permData } = useGetQuery({ url: '/admin/permissions' })

  const rolePerms = addSlug(roleData?.role?.permissions) || []
  const allPerms = addSlug(permData?.permissions || [])
  const [state, setState] = useState(rolePerms)

  const handler = ({ target: { value } }) => {
    setState(value.map((v) => allPerms.find((ap) => ap.slug === v)))
  }

  if (!roleData?.role) return null
  return (
    <Modal $show={role} hideModal={() => toggle(false)}>
      <Title level="3">{role}</Title>
      <Typeahead
        multiselect={true}
        onSelect={handler}
        selected={state?.filter(Boolean)?.map((s) => s.slug) || []}
        collection={allPerms?.map((p) => p.slug)}
      />
      {state.map((p) => (
        <Tag key={p.subject + p.action}>
          {p?.subject}:{p?.action}
        </Tag>
      ))}
    </Modal>
  )
}
